import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="border-t bg-background noise-overlay">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <img src="/ap-logo.png" alt="Automation Prime" className="h-10 w-auto" />
              <h3 className="font-semibold text-lg" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>Automation Prime</h3>
            </div>
            <p className="text-sm text-muted-foreground">Building the future through automation. We create, launch, grow, partner with, and acquire companies that simplify how businesses operate.</p>
          </div>
          <div>
            <h4 className="font-medium mb-4">Company</h4>
            <div className="space-y-2 text-sm">
              <Link to="/about" className="block text-muted-foreground hover:text-foreground transition-colors">About Us</Link>
              <Link to="/portfolio" className="block text-muted-foreground hover:text-foreground transition-colors">Portfolio</Link>
              <Link to="/business-builder" className="block text-muted-foreground hover:text-foreground transition-colors">Business Builder</Link>
            </div>
          </div>
          <div>
            <h4 className="font-medium mb-4">Invest</h4>
            <div className="space-y-2 text-sm">
              <Link to="/investment-opportunities" className="block text-muted-foreground hover:text-foreground transition-colors">Investment Opportunities</Link>
              <Link to="/contact" className="block text-muted-foreground hover:text-foreground transition-colors">Partner With Us</Link>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t text-center text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Automation Prime Holdings. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}